<template>
  <div class="solution-page-content">
    <banner>
      科技驱动&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;业务为要&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;跨界创新
    </banner>

    <!--行模板一-->
    <div class="panel-main solution-item"
         v-for="(item, idx) in solution"
         :key="idx">

      <div class="public-layout-table2" :id="item.id" v-if="idx%2 === 0">
        <div class="panel-item">
          <div class="content-wrapper">
            <h2>{{item.title}}</h2>
            <h3>{{item.subtitle.toUpperCase()}}</h3>
            <p>{{item.abstrct}}</p>
            <router-link class="view-link"
                         v-if="item.link"
                         :to="{path: item.link}">{{item.label}}</router-link>
          </div>
        </div>
        <div class="panel-item">
          <div class="img-wrapper">
            <img :src="item.cover"
                 :alt="item.title" />
          </div>
        </div>
      </div>

      <div class="public-layout-table2" :id="item.id" v-else>
        <div class="panel-item">
          <div class="img-wrapper">
            <img :src="item.cover"
                 :alt="item.title" />
          </div>
        </div>
        <div class="panel-item">
          <div class="content-wrapper">
            <h2>{{item.title}}</h2>
            <h3>{{item.subtitle.toUpperCase()}}</h3>
            <p>{{item.abstrct}}</p>
            <router-link class="view-link"
                         v-if="item.link"
                         :to="{path: item.link}">
              {{item.label}}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import HeaderBar from '../components/HeaderBar'
  import FooterBar from '../components/FooterBar'
  import Banner from '../components/Banner'

  export default {
    data () {
      return {
        solution: [{
          id: 'bio',
          title: '生物识别身份认证',
          subtitle: 'biometric identity authentication.',
          abstrct: '以全渠道多模态生物认证平台为核心，构建身份认证基础能力，建设面向不同业务的认证系统。通过多样化的认证渠道和多种生物识别技术的不同组合，满足业务系统个性化认证需求。平台现已广泛应用于养老、就业、工伤等资格认证和医保控费、教育考试等身份认证领域。',
          cover: require('../../static/images/solution/sol-bio.jpg')
        }, {
          id: 'train',
          title: '职业培训云平台',
          subtitle: 'PROFESSIONAL EDUCATION CLOUD PLATFORM.',
          abstrct: '运用移动互联网、流媒体、云服务、生物认证等技术，构建集培训、考试、认证、就业资讯等为一体的专业教育平台。同时，有效整合优质培训资源，打造精品课程体系，形成平台运营能力。为学员提供便捷、高效、优质的职业培训通道，实现职业培训与公共服务的新突破。',
          cover: require('../../static/images/solution/sol-training.jpg')
        }, {
          id: 'public',
          title: '智慧化公共服务平台',
          subtitle: 'intelligent public service platform.',
          abstrct: '敏锐把握从“互联网+”迈入“智能+”时代的用户需求，以自然语言处理、深度学习及知识图谱为核心技术，构建以自然语言为第一交互界面的新型“智能+”公共服务平台，可轻松实现一点接入、自然交互、精准识别、需求感知等智慧化服务，满足用户从信息咨询到业务办理的全方位需求，打造“智能+”时代最前沿、最有效的交互体验。',
          cover: require('../../static/images/solution/sol-service.jpg')
        }, {
          id: 'drgs',
          title: '智慧医保',
          subtitle: 'medical insurance.',
          abstrct: '结合医保行业权威专家团队，应用人工智能、区块链、大数据分析等技术，构建新医保数据驱动的行业解决方案。为医疗产业链的各方提供了“三医联动”新局面下的数据服务产品，帮助医保、医院和医药企业制定政策/策略、提升效率。',
          cover: require('../../static/images/solution/sol-host.jpg')
        }]
      }
    },
    methods: {
      locArchor () {
        let anchor = this.$route.query.name

        if (!anchor) {
          return false
        }
        this.$el.querySelector('#' + anchor).scrollIntoView()
      }
    },
    components: {
      HeaderBar,
      FooterBar,
      Banner
    },
    mounted () {
      this.$nextTick(this.locArchor)
    }
  }
</script>

<style lang="scss">
  @import '../assets/style/base.scss';
  @import '../assets/style/public.scss';

  .solution-page-content {
    .pulic-banner-container {
      background-image: url('../assets/images/banners/bg-solution.jpg');
      margin-bottom: 95px;
      .banner-content .banner-txt{
        font-size: 30px;
        color: #fff;
        text-shadow: 0 0 20px rgba(8, 44, 54, 1);
      }
    }
    .solution-item{
      margin-top: 40px;
      background-color: #e3e5e7;
      .public-layout-table2{
        min-height: 540px;
        &:before{
          content: ' ';
          display: block;
          width: 100%;
          height: 95px;
          background-color: #fff;
          position: absolute;
        }
      }
      &:nth-child(even){
        .panel-item{
          &:first-child{
            margin-top: 95px;
          }
          &:last-child{
            position: relative;
            left: 462px;
            background-color: #fff;
          }
          .content-wrapper{
            float: right;
            margin-right: 90px;
          }
          .img-wrapper{
            margin-left: -485px;
          }
        }
      }

      &:nth-child(odd){
        .panel-item{
          &:first-child{
            background-color: #fff;
            position: relative;
            left: -435px;
          }
          &:last-child{
            margin-top: 95px;
          }
          .content-wrapper{
            margin-left: 90px;
          }
          .img-wrapper{
            float: right;
            margin-right: -442px;
          }
        }
      }

      .content-wrapper{
        width: 405px;
        margin-top: 110px;
        h2{
          font-size: 22px;
          color: #3b3b3b;
          font-weight: bold;
          margin-bottom: 8px;
        }
        h3{
          font-size: 14px;
          color: #888888;
          font-weight: lighter;
          margin-bottom: 35px;
        }
        p{
          color: #3b3b3b;
          font-size: 14px;
          line-height: 2em;
        }
        .view-link{
          border: 1px solid #7c7c7c;
          border-radius: 2px;
          color: #7c7c7c;
          font-size: 16px;
          font-weight: bold;
          padding: 0 16px;
          height: 45px;
          line-height: 45px;
          display: inline-block;
          margin-top: 75px;
          transition: all .2s ease;
          &:after{
            content: ' ';
            width: 1em;
            height: 45px;
            margin-left: 1em;
            float: right;
            display: inline-block;
            background: url('../assets/images/to-link.png') no-repeat center center;
          }
          &:hover{
            background-color: #00ccff;
            border-color: #00ccff;
            color: #fff;
            &:after{
              background-image: url('../assets/images/to-link-active.png');
            }
          }
        }
      }
      .img-wrapper{
        width: 566px;
        height: 381px;
        overflow: hidden;
        background-color: #fff;
        box-shadow: 2px 0 9px rgba(0, 0, 0, .53);
        margin-top: 10px;
        img{
          display: block;
          width: 100%;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pc/Solution.vue